import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=42b7e1a6&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=42b7e1a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b7e1a6",
  null
  
)

export default component.exports